/**
 * Demande au navigateur de ne pas évincer IndexedDB (indispensable sur iOS,
 * qui purge le stockage des sites non installés après 7 jours sans visite).
 * Retourne true si le stockage est persistant.
 */
export async function demanderStockagePersistant(): Promise<boolean> {
  if (!navigator.storage?.persist) return false
  if (await navigator.storage.persisted()) return true
  return navigator.storage.persist()
}

/** iPhone/iPad, y compris les iPad qui se présentent comme un Mac. */
export function estIos(): boolean {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
}

/** L'app est lancée depuis l'écran d'accueil (PWA installée). */
export function estInstallee(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true
  )
}
